module.exports = __webpack_public_path__ + "img/gai.ec9c6cf7.jpg";